import { useState } from 'react';
import Hero from './components/Hero';
import MenuPreview from './components/MenuPreview';
import About from './components/About';
import PhotoGallery from './components/PhotoGallery';
import LocationHours from './components/LocationHours';
import Reviews from './components/Reviews';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <MenuPreview />
      <About />
      <PhotoGallery />
      <LocationHours />
      <Reviews />
      <CTASection />
      <Footer />
    </div>
  );
}